import { render } from "./CloseOrderPanel.vue?vue&type=template&id=3624c6b5&scoped=true"
import script from "./CloseOrderPanel.vue?vue&type=script&lang=js"
export * from "./CloseOrderPanel.vue?vue&type=script&lang=js"

import "./CloseOrderPanel.vue?vue&type=style&index=0&id=3624c6b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3624c6b5"]])

export default __exports__